import props from "./../../../src-utils/propDefiner";

export default {
  ...props("dataSet", { type: Array, default: () => [] }, "pm-grid"),
  ...props("count", { type: Number }, "pm-grid"),
  ...props("gap", { type: Number }, "pm-grid"),
  ...props("cols", { type: Number, default: 12 }, "pm-grid"),
};
